import { render, staticRenderFns } from "./HCaptcha.vue?vue&type=template&id=939ac284&"
import script from "./HCaptcha.vue?vue&type=script&lang=js&"
export * from "./HCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports